import { IsMatchingRegexpValidator } from './IsMatchingRegexp.validator'
import { ValidationFunction } from './Validator.interface'

const VALID_NUMBER_ERROR = 'Must be a valid number.'
const VALID_NUMBER_REGEX = new RegExp('^[-]?[0-9]*[.]?[0-9]+$')
export const IsValidNumberValidator =
  (error = VALID_NUMBER_ERROR): ValidationFunction =>
  (value) => {
    if (typeof value === 'undefined') {
      return ''
    }

    if (typeof value === 'string') {
      return IsMatchingRegexpValidator(VALID_NUMBER_REGEX, error)(value)
    }

    const parsedNumber: number = typeof value === 'number' ? value : parseFloat(value.toString())
    if (isNaN(parsedNumber)) {
      return error
    }

    return ''
  }
